/* global axios */
import AsteriskApiClient from './index';

class DidsAPI extends AsteriskApiClient {
  constructor() {
    super('dids');
  }

  // GET /api/v1/accounts/:account_id/asterisk/dids
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/asterisk/dids/:id
  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/dids
  create(data) {
    return axios.post(this.url, data);
  }

  // PUT /api/v1/accounts/:account_id/asterisk/dids/:id
  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/asterisk/dids/:id
  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/dids/:id/clone
  clone(id, newDidNumber) {
    return axios.post(`${this.url}/${encodeURIComponent(id)}/clone`, {
      new_did_number: newDidNumber,
    });
  }

  // GET /api/v1/accounts/:account_id/asterisk/dids/:id/schedules
  getSchedules(didId) {
    return axios.get(`${this.url}/${encodeURIComponent(didId)}/schedules`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/dids/:id/create_schedule
  createSchedule(didId, data) {
    return axios.post(
      `${this.url}/${encodeURIComponent(didId)}/create_schedule`,
      data
    );
  }

  // PUT /api/v1/accounts/:account_id/asterisk/dids/:id/schedules/:scheduleId
  updateSchedule(didId, scheduleId, data) {
    return axios.put(
      `${this.url}/${encodeURIComponent(didId)}/schedules/${encodeURIComponent(scheduleId)}`,
      data
    );
  }

  // DELETE /api/v1/accounts/:account_id/asterisk/dids/:id/schedules/:scheduleId
  deleteSchedule(didId, scheduleId) {
    return axios.delete(
      `${this.url}/${encodeURIComponent(didId)}/schedules/${encodeURIComponent(scheduleId)}`
    );
  }
}

export default new DidsAPI();
